import React from 'react';
import NavBar from '../NavBar';
import { Footer } from '../Footer/Footer';

import './TermsOfService.css';

export const TermsOfService = () => {
  return (
    <>
      <NavBar currentPath="terms_of_service" />
      <div className="terms-of-service-container">
        <div>
          <h1 className="terms-of-service-header"> General Terms of Use </h1>
          <p>
            By accessing or using the CashClever Platform ("the Platform"), you agree to be bound by
            these General Terms of Use. These terms govern your use of the Platform, including any
            content, features, and services provided. If you do not agree with these terms, you are
            prohibited from using the Platform.
          </p>
          <p>
            You agree to use the Platform in accordance with applicable laws and regulations and
            will not misuse the Platform or engage in activities that could harm, disrupt, or
            interfere with the functionality of the Platform. The Platform reserves the right to
            modify, suspend, or terminate your access at any time, without prior notice, if these
            Terms of Use are violated.
          </p>
          <h3>CashClever Additional Terms of Use</h3>
          <p>
            In addition to the General Terms of Use, the following terms apply to users of the
            CashClever services:
          </p>

          <p>
            Eligibility: To use the CashClever services, you must be at least 18 years old and have
            the legal capacity to enter into binding agreements.
          </p>
          <p>
            Account Information: You are responsible for maintaining the accuracy and security of
            your account information. Any unauthorized use of your account should be reported
            immediately.
          </p>
          <p>
            Third-Party Lenders: CashClever connects you to third-party lenders but does not
            directly lend money. We do not guarantee any specific loan offers or approval.
          </p>
          <p>
            Service Availability: The services offered by CashClever are subject to availability and
            may be modified, suspended, or discontinued at any time.
          </p>

          <h3>Credit Journey Terms and Conditions</h3>
          <p>
            The Credit Journey Terms and Conditions govern your use of our credit monitoring
            services. By signing up for these services, you acknowledge and agree to the following:
          </p>

          <p>
            Credit Report Access: You understand that CashClever may provide you with access to
            credit reports and credit scores through third-party services, and you consent to the
            collection of this information for the purpose of offering credit-related services.
          </p>
          <p>
            Usage of Data: The data from your credit report is used to help match you with
            appropriate lenders or financial products. You agree to allow us to use this data to
            assess your eligibility for various financial products.
          </p>
          <p>
            Accuracy of Information: You agree to provide accurate and up-to-date information when
            using the Credit Journey service. Inaccurate data may result in delays or an inability
            to provide you with suitable financial products.
          </p>
          <p>
            Service Charges: Some services within Credit Journey may be subject to fees. Any
            applicable charges will be clearly disclosed before you opt-in.
          </p>

          <h3>Express Written Consent to Call & Text</h3>
          <p>
            By providing your phone number, you expressly consent to receive calls and text messages
            from CashClever, its partners, and third-party lenders. These calls and messages may
            include information about your loan application, credit offers, promotional materials,
            or other relevant updates.
          </p>

          <p>
            Auto-Dialed or Pre-recorded Calls: You consent to receive calls made using an automatic
            dialing system or prerecorded messages.
          </p>
          <p>
            Opt-Out: You can withdraw your consent at any time by replying "STOP" to any text
            message or notifying us through our customer service.
          </p>
          <p>No Fees: Standard message and data rates may apply for receiving SMS/text messages.</p>

          <h3>SMS / Text Messages Terms of Use</h3>

          <p>
            Opt-In: By submitting your phone number to the Platform, you consent to receive SMS/text
            messages from CashClever and its third-party partners regarding loan offers, promotions,
            or account-related updates.
          </p>
          <p>
            Message Frequency: You may receive recurring messages related to your loan application,
            account status, or promotional offers.
          </p>
          <p>
            Opt-Out: To stop receiving SMS/text messages, you can reply "STOP" to any received
            message. You may also contact customer service to remove your number from our messaging
            list.
          </p>
          <p>
            Message and Data Rates: You are responsible for any message and data charges from your
            mobile carrier.
          </p>
          <h3>Consent to Obtain Credit Report</h3>
          <p>
            By using our services, you grant us your explicit consent to obtain your credit report
            from a credit reporting agency. This consent is provided for the purpose of:
          </p>

          <p>
            Eligibility Assessment: Determining your eligibility for financial products and loan
            offers.
          </p>
          <p>
            Soft Credit Check: We will perform a soft credit check, which will not impact your
            credit score, but may be used to assess your creditworthiness and match you with
            suitable loan options.
          </p>
          <p>
            Third-Party Sharing: We may share your credit information with third-party lenders and
            financial partners to facilitate loan offers and other financial services.
          </p>
          <p>
            Right to Withdraw Consent: You have the right to withdraw your consent to the credit
            report check at any time. However, this may limit the ability of lenders to evaluate
            your application.
          </p>

          <h3>Consent for Electronic Disclosures</h3>
          <p>
            By using our Platform, you consent to receive disclosures, notices, and other
            communications electronically. These communications may include:
          </p>

          <p>
            Legal Notices: Any legal notices or communications required by law to be delivered to
            you regarding the loan application process.
          </p>
          <p>
            Marketing Communications: Promotional offers, updates, and news related to our products
            and services.
          </p>
          <p>
            Withdrawal of Consent: You may withdraw your consent for electronic communications at
            any time. If you choose to withdraw consent, you may request physical copies of required
            disclosures.
          </p>
          <p>
            Compatibility: By consenting, you acknowledge that you have access to an electronic
            device (such as a computer or smartphone) and an email address to receive electronic
            communications.
          </p>

          <h3>Privacy / Consent to Share</h3>
          <p>
            We value your privacy and are committed to protecting your personal data. By using the
            Platform, you provide your consent for us to share your information under the following
            conditions:
          </p>

          <p>
            Third-Party Sharing: We may share your information with third-party lenders and
            financial partners for the purpose of providing loan offers and related services. Data
            Security: We implement industry-standard security measures to protect your data and
            ensure that your information is handled with care.
          </p>
          <p>
            Usage of Data: Your personal and financial information may be used for the purposes of
            evaluating your loan eligibility, improving our services, and marketing financial
            products to you.
          </p>
          <p>
            Your Rights: You have the right to request access to, correction, or deletion of your
            personal information. Please contact us for assistance with any data-related inquiries.
          </p>
        </div>
      </div>

      <Footer currentPath={'/terms_of_service'} />
    </>
  );
};
